<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » 掲示板（スレッド）詳細（追加・編集・閲覧）の説明
  </div>

<div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

  <mat-card appearance="outlined" class="manual-card">
    <mat-card-header>
      <mat-card-title><span>掲示板（スレッド）詳細（追加・編集・閲覧）の説明</span></mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <div class="manual-img">
        <img src="assets/img/manual/board-thread-dialog.png" width="100%">
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/A.png"> 閉じるボタン
      </div>
      <div class="manual-explain">
        クリックすることでダイアログを閉じます。<br>
        その際、編集した内容は保存されません。
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/B.png"> 名称
      </div>
      <div class="manual-explain">
        名称を設定します。<br>
        閲覧時には設定できません。<br>
        <span class="manual-explain-notes">※必須項目</span>
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/C.png"> 内容
      </div>
      <div class="manual-explain">
        内容を設定します。<br>
        閲覧時には設定できません。<br>
        <span class="manual-explain-notes">※必須項目</span>
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/D.png"> 画像
      </div>
      <div class="manual-explain">
        画像を設定します。<br>
        閲覧時には設定できません。
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/E.png"> 削除ボタン
      </div>
      <div class="manual-explain">
        クリックすることでスレッドが削除されます。<br>
        スレッドに投稿されたコメントも削除されます。<br>
        閲覧時には表示されません。
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/F.png"> 更新ボタン
      </div>
      <div class="manual-explain">
        クリックすることで編集内容が更新されます。<br>
        閲覧時には表示されません。
      </div>

      </mat-card-content>
    </mat-card>

  </div>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">Manual Top</a> » Bulletin Board (Thread) Details (Add/Edit/View) Description
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

      <mat-card class="manual-card">
        <mat-card-header>
          <mat-card-title><span>Bulletin Board (Thread) Details (Add/Edit/View) Description</span></mat-card-title>
        </mat-card-header>

        <mat-card-content>
          <div class="manual-img">
            <img src="assets/img/manual/en_board-thread-dialog.png" width="100%">
          </div>

          <div class="manual-explain-title">
            <img src="assets/img/manual/A.png"> Close Button
          </div>
          <div class="manual-explain">
            Clicking this button closes the dialog.<br>
            Edited content will not be saved.
          </div>

          <div class="manual-explain-title">
            <img src="assets/img/manual/B.png"> Name
          </div>
          <div class="manual-explain">
            Set the name.<br>
            Cannot be set in view mode.<br>
            <span class="manual-explain-notes">*Required field</span>
          </div>

          <div class="manual-explain-title">
            <img src="assets/img/manual/C.png"> Content
          </div>
          <div class="manual-explain">
            Set the content.<br>
            Cannot be set in view mode.<br>
            <span class="manual-explain-notes">*Required field</span>
          </div>

          <div class="manual-explain-title">
            <img src="assets/img/manual/D.png"> Image
          </div>
          <div class="manual-explain">
            Set the image.<br>
            Cannot be set in view mode.
          </div>

          <div class="manual-explain-title">
            <img src="assets/img/manual/E.png"> Delete Button
          </div>
          <div class="manual-explain">
            Clicking this button deletes the thread.<br>
            Comments posted to the thread will also be deleted.<br>
            Not displayed in view mode.
          </div>

          <div class="manual-explain-title">
            <img src="assets/img/manual/F.png"> Update Button
          </div>
          <div class="manual-explain">
            Clicking this button updates the edited content.<br>
            Not displayed in view mode.
          </div>
        </mat-card-content>
    </mat-card>

  </div>
</div>
